import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAttach = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.9898 7.59998L8.32977 12.88C7.88977 13.3 7.63979 13.87 7.65979 14.46C7.67979 15.05 7.91978 15.61 8.36978 16.02C8.81978 16.43 9.42978 16.67 10.0598 16.67C10.6898 16.67 11.2898 16.45 11.7498 16.04L17.6098 10.59C18.4898 9.75003 18.9698 8.61 18.9598 7.44C18.9498 6.26 18.4498 5.14 17.5598 4.31C16.6698 3.48 15.4598 3.01 14.1998 3C12.9398 3 11.7198 3.44001 10.8098 4.26001L5.1398 9.53003C4.4698 10.15 3.93979 10.89 3.56979 11.71C3.20979 12.53 3.02979 13.4 3.02979 14.28C3.02979 15.16 3.21979 16.04 3.56979 16.85C3.93979 17.67 4.4598 18.41 5.1398 19.03C5.8198 19.65 6.6098 20.15 7.4798 20.49C8.3598 20.83 9.29979 21 10.2498 21C11.1998 21 12.1298 20.83 13.0198 20.49C13.8898 20.15 14.6898 19.66 15.3598 19.03L21.0298 13.76",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgAttach;
